import { alpha, Box, styled, Typography } from '@sb/cc-design-system';

export const ProductOverrideRightSideBarWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

export const ProductOverrideRightSideBarHeader = styled(Typography)(
  ({ theme }) => `
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: ${alpha(theme.palette.secondary.contrastText, 0.6)};
`,
);

export const ProductOverrideRightSideBarContentWrapper = styled(Box)<{
  $hasSelectedProduct?: boolean;
}>(
  ({ $hasSelectedProduct }) => `
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  gap: ${$hasSelectedProduct ? '0' : '12px'};
  width: 100%;
  min-height: 0;
  overflow-y: auto;
  padding-right: 16px;
`,
);

export const EmptyStateWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 28px;
`;

export const EmptyStateMessage = styled(Typography)(
  ({ theme }) => `
  width: 245px;
  text-align: center;
  color: ${alpha(theme.palette.secondary.contrastText, 0.38)};
`,
);

export const InitialLoadingWrapper = styled(Box)`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
`;
